import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Menu } from 'antd';
import { HomeOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';

const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.xl};
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
  }
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
  transition: all 0.3s ease;
  
  &:hover {
    filter: brightness(1.1);
  }
`;

const LogoText = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-left: 8px;
  font-family: 'Inter', 'SF Pro Display', sans-serif;
`;

const NavItems = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const NavLink = styled(Link)`
  color: #64748b;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
  }
  
  &.active {
    color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
  }
`;

const { TabPane } = Tabs;

const Navigation = () => {
  const location = useLocation();

  return (
    <NavigationWrapper>
      <LogoContainer to="/">
        <LogoImage 
          src="/images/breeze-snow-logo.svg" 
          alt="Breeze Snow Logo"
        />
      </LogoContainer>
      
      <NavItems>
        <NavLink 
          to="/" 
          className={location.pathname === '/' ? 'active' : ''}
        >
          首页
        </NavLink>
        <NavLink 
          to="/products" 
          className={location.pathname === '/products' ? 'active' : ''}
        >
          装备
        </NavLink>
        <NavLink 
          to="/search" 
          className={location.pathname === '/search' ? 'active' : ''}
        >
          搜索
        </NavLink>
      </NavItems>
    </NavigationWrapper>
  );
};

export default Navigation;